<template>
  <div>
    <div style="margin-bottom: 15px">
      <jd-tip>
        <p>
          礼品卡中奖后，用户需要在礼品卡详情页查看卡密及激活方式
        </p>
      </jd-tip>
    </div>
    <el-form :model="giftCardForm" label-width="130px">
      <slot name="formSlot"></slot>
      <el-form-item label="选择礼品卡:">
        <el-select
          v-model="giftCardForm.region"
          placeholder="请选择"
          @change="selectGift"
        >
          <el-option
            v-for="item in giftCardList"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <jd-button type="blueText" style="margin: 0px 8px" @click="refreshGiftCard"
          >刷新</jd-button
        >
        <jd-button style="margin-right: 8px" type="blue" @click="createGiftCard"
          >创建礼品卡</jd-button
        >
        <p>
          剩余
          <span style="color: #fe4d45">{{ giftCardForm.budgetRemain }}</span>
          张
        </p>
      </el-form-item>
      <el-form-item label="单份奖品:">
        <el-input
          v-model="giftCardForm.num"
          style="width: 220px"
          :disabled="true"
        ></el-input>
        张
      </el-form-item>
      <!-- <el-form-item style="margin-left: -130px">
        <jd-button
          type="blue"
          :styleTextObj="{width: '180px'}"
          :disabled="giftCardForm.budgetRemain==0"
          @click="handleSelectGiftCard"
          >选择礼品卡</jd-button
        >
      </el-form-item> -->
    </el-form>
    <div style="width: 100%;display: flex;justify-content: end;">
        <jd-button
          type="blue"
          :disabled="giftCardForm.budgetRemain==0"
          @click="handleSelectGiftCard"
          >确定</jd-button
        >
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    giftData: {
      type: Object,
      default: ()=>({})
    },
    giftCardList: {
      type: Array,
      default: ()=>([])
    }
  },
  data() {
    return {
      loading: false,
      giftCardForm: {
        region: "",
        num: "1",
        budgetRemain: "",
        logo: "",
        name: ""
      }
    };
  },
  computed: {},
  watch: {
    giftData:{
      handler(newVal) {
      this.giftCardForm.region = newVal.region
      this.giftCardForm.budgetRemain = newVal.budgetRemain
      this.giftCardForm.logo = newVal.logo
      this.giftCardForm.name = newVal.name
    },
    deep: true,
    immediate: true
    }
  },
  mounted() {
    
  },
  methods: {
    refreshGiftCard() {
      this.$emit("refreshGiftCard")
    },
    createGiftCard() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 7 },
      });
      window.open(routeUrl.href, "_blank");
    },
    selectGift(id) {
      let obj = this.giftCardList.find(item=>item.id == id);
      this.giftCardForm.region = obj.id
      this.giftCardForm.logo = obj.planImg
      this.giftCardForm.budgetRemain = obj.actualBalance
      this.giftCardForm.name = obj.planName
    },
    handleSelectGiftCard() {
      this.$emit("handleGetGiftCard",this.giftCardForm)
    }
  },
};
</script>
<style lang="scss" scoped></style>
